const SELECTORS = {
  swiperContainer: '.js-quick-menu__slider',
};

/**
 * Initialize swiper
 *
 * @param {object} Swiper swiper class object
 */
const initQuickMenu = (Swiper) => {
  const swiperContainer = document.querySelector(SELECTORS.swiperContainer);

  const swiperOptions = {
    slidesPerView: 'auto',
    spaceBetween: 24,
    autoplay: false,
    allowSlideNext: true,
    allowSlidePrev: true,
    breakpoints: {
      725: {
        allowSlideNext: false,
        allowSlidePrev: false,
      },
      960: {
        spaceBetween: 64,
        allowSlideNext: false,
        allowSlidePrev: false,
      },
    },
  };
  if (swiperContainer) {
    // eslint-disable-next-line no-new
    new Swiper(swiperContainer, swiperOptions);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  window.LoadSwiper.then((module) => {
    initQuickMenu(module.Swiper);
  });
});
